// ============================================
// STORAGE ADAPTER - Runtime
// ============================================

import type { StorageAdapter, StorageNamespace } from '../types/storage';
import type { StorageSchemaMap } from '../types/options';

// Adapter variable - gets set by app-specific init
export let storageAdapter: StorageAdapter = {
  get: async () => {
    throw new Error('Storage adapter not initialized');
  },
  set: async () => {
    throw new Error('Storage adapter not initialized');
  },
  remove: async () => {
    throw new Error('Storage adapter not initialized');
  },
};

export const setStorageAdapter = (adapter: StorageAdapter) => {
  storageAdapter = adapter;
};

// ============================================
// TYPED STORAGE WRAPPERS
// ============================================

type Prettify<T> = { [K in keyof T]: T[K] } & {};

export async function getStorage<
  C extends keyof StorageSchemaMap = 'ext',
  N extends keyof StorageSchemaMap[C] & string = keyof StorageSchemaMap[C] & string,
  K extends keyof StorageSchemaMap[C][N] & string = keyof StorageSchemaMap[C][N] & string,
>(namespace: N, keys: K[]): Promise<Prettify<Partial<Pick<StorageSchemaMap[C][N], K>>>> {
  return storageAdapter.get(namespace as StorageNamespace, keys) as Promise<
    Prettify<Partial<Pick<StorageSchemaMap[C][N], K>>>
  >;
}

export async function setStorage<
  C extends keyof StorageSchemaMap = 'ext',
  N extends keyof StorageSchemaMap[C] & string = keyof StorageSchemaMap[C] & string,
>(namespace: N, updates: Partial<StorageSchemaMap[C][N]>): Promise<void> {
  return storageAdapter.set(namespace as StorageNamespace, updates as Record<string, any>);
}

export async function removeStorage<
  C extends keyof StorageSchemaMap = 'ext',
  N extends keyof StorageSchemaMap[C] & string = keyof StorageSchemaMap[C] & string,
>(namespace: N, key: keyof StorageSchemaMap[C][N] & string): Promise<void> {
  return storageAdapter.remove(namespace as StorageNamespace, key);
}
